// API Configuration
// Uses environment variable for flexibility between local and deployed environments
export const API_BASE_URL = process.env.REACT_APP_API_BASE ?? 'http://localhost:3000';

// Helper function to build full API URLs
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE_URL}${cleanEndpoint}`;
};
